import React, { createContext, useContext, useState, useEffect, ReactNode } from "react";

interface ModalContextProps {
    showModal: boolean;
    setShowModal: (value: boolean) => void;
}

const ModalContext = createContext<ModalContextProps | undefined>(undefined);

export const useModalContext = () => {
    const context = useContext(ModalContext);
    if (!context) {
        throw new Error("useModalContext must be used within a ModalProvider");
    }
    return context;
};

export const ModalProvider = ({ children }: { children: ReactNode }) => {
    const [showModal, setShowModal] = useState<boolean>(false);

    return <ModalContext.Provider
            value={{ showModal, setShowModal }}
        >
            {children}
        </ModalContext.Provider>
};